export default __webpack_public_path__ + "static/media/depart-transcend.2d21e591.png";